// CCshopAdminRequestIntro.tsx
import { Col, Row } from "react-bootstrap";
import "../intro/intro.css";
import placeholder from "@/assets/placeholder.webp";
import ArrowButton from "@/components/common/buttons/ArrowButton";

interface Props {
  onClick: () => void;
}

const CCshopAdminRequestIntro = ({ onClick }: Props) => {
  return (
	<div className="intro-row">
	  <Row className="body-row">
		<Col xs={12} lg={6} className="contact-info">
		  <Row className="stack-one">
			<Row className="contact-head eyebrow-body">CC Shop Demo</Row>
			<Row className="title-2">
			  Solicită acces administrator pentru demo-ul nostru e-commerce
			</Row>
		  </Row>
		  <Row className="body contact-text">
			Completează formularul de mai jos și vei primi credențialele de acces 
			pentru panoul de administrare al demo-ului CC Shop în maxim 48 de ore, pe adresa de email specificată!<br /><br />
			Vei putea testa toate funcționalitățile: gestionarea produselor, 
			comenzilor, facturilor, clientilor, etc.<br /><br />
			De asemenea, vei primi, din partea pixado.ro, și o ofertă de online marketing.
		  </Row>
		</Col>
		<Col className="img-col" xs={12} lg={6}>
		  <div className="contact-img-wrapper">
			<img src={placeholder} className="contact-img" alt="CC Shop Demo" />
		  </div>
		  <ArrowButton onClick={onClick} className="contact-decor" />
		</Col>
	  </Row>
	</div>
  );
};

export default CCshopAdminRequestIntro;
